import React from 'react'

interface IProps {
    className?: string
    children?: any
}

const Span: React.FC<IProps> = ({className, children}) => {
    return <span className={`font-sans ${className}`}>{children}</span>
}

export default Span
